import { render, staticRenderFns } from "./assign-reviewer.vue?vue&type=template&id=564f8328&"
import script from "./assign-reviewer.component.ts?vue&type=script&lang=ts&"
export * from "./assign-reviewer.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports